import {
  keikkaBetoni_cacheName,
  cache_clear,
  cache_read,
  cache_write,
  keikka_cacheName,
} from "src/components/js/CacheFunctions";
import { checkResponse } from "src/components/js/statics1";

export const RasitusLuokatArr = [
  "X0",
  "XC1",
  "XC2",
  "XC3",
  "XC4",
  "XD1",
  "XD2",
  "XD3",
  "XF1",
  "XF2",
  "XF3",
  "XF4",
  "XS1",
  "XS2",
  "XS3",
  "XA1",
  "XA2",
  "XA3",
];

export function betoni_getString(betoni) {
  if (!betoni) return "";
  // Get the base concrete string
  const baseString = betoni_getString_noAttr(betoni);
  // Extract attributes if they exist
  const attrs = betoni.attr?.attr || betoni.attr || [];
  const attrString = attrs.map((attr) => attr.attrNimike).join(", ");
  // const attrString = [attrString1, attrString2].filter((s) => s).join(", ");
  // Combine strings, clean up, and validate length
  const combinedString = removeEiTietoaFromBetoniString(
    [baseString, attrString].filter((s) => s).join(" ")
  );
  const a = combinedString.length > 4 ? combinedString : "";
  return a;
}

function removeEiTietoaFromBetoniString(betoniString) {
  if (!betoniString) return "";

  // Use a single regex pattern for better performance
  const cleanString = betoniString
    .replace(/(?:Ei tietoa|ei tietoa|undefined)/g, "")
    // Handle multiple spaces that might result from removed text
    .replace(/\s+/g, " ")
    .trim();

  return cleanString;
}

export function betoni_getString_noAttr(betoni) {
  if (!betoni) return "";

  // Define properties to extract and join
  const parts = [
    (betoni.laatu?.nimike || betoni.laatuNimike)?.trim() || "",
    betoni.isNopea ? "nopea" : "",
    (betoni.raeKoko?.raeKokoString || betoni.raeKokoSelite)?.trim() || "",
    (betoni.lujuus?.lujuusString || betoni.lujuusSelite)?.trim() || "",
    (betoni.notkeus?.notkeusString || betoni.notkeusSelite)?.trim() || "",
    (betoni.rasitus?.rasitusluokatString || betoni.rasitusluokat)?.trim() || "",
    (betoni.kayttoIka?.kayttoIkaString || betoni.kayttoIkaSelite)?.trim() || "",
  ];

  // Join non-empty parts with a single space
  const result = parts.filter((part) => part).join(" ");

  return removeEiTietoaFromBetoniString(result);
}

export async function keikka_fetchKeikkaId_by_foreignKey(foreignKey, token) {
  const url1 = import.meta.env.VITE_SERVER_URL + "/api/keikka/getByForeignKey/" + foreignKey;
  const c = cache_read(keikka_cacheName, url1);
  if (c) return c;
  const response = await fetch(url1, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "keikkaClass.js:getKeikkaIdOriginByForeignKey");
  if (!cResponse.success) return false;
  const result = cResponse.data;
  let _keikkaId = null;
  let _originId = 1;
  if (result.length > 0) {
    _keikkaId = result[0].keikkaId;
    _originId = result[0].originId;
    cache_write(keikka_cacheName, url1, { keikkaId: _keikkaId, originId: _originId }, 3600);
  }
  return { keikkaId: _keikkaId, originId: _originId };
}

export async function betoni_fetchKayttoIkaList() {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/kayttoika/list";
  const c = cache_read(keikkaBetoni_cacheName, url);
  if (c) return c;
  const response = await fetch(url);
  const json = await response.json();
  cache_write(keikkaBetoni_cacheName, url, json, 0);
  return json;
}
export async function betoni_fetchLujuusList() {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/lujuus/list";
  const c = cache_read(keikkaBetoni_cacheName, url);
  if (c) return c;
  const response = await fetch(url);
  const json = await response.json();
  cache_write(keikkaBetoni_cacheName, url, json, 0);
  return json;
}
export async function betoni_fetchNotkeusList() {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/notkeus/list";
  const c = cache_read(keikkaBetoni_cacheName, url);
  if (c) return c;
  const response = await fetch(url);
  const json = await response.json();
  cache_write(keikkaBetoni_cacheName, url, json, 0);
  return json;
}
export async function betoni_saveRasitusToDB(betoni, token, varmenne = null, keikkaId = 0) {
  cache_clear(keikkaBetoni_cacheName);
  const keikkaBetoniId = betoni.keikkaBetoniId;
  if (keikkaBetoniId === 0) return;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaBetoniId: keikkaBetoniId,
      rasitusluokat: betoni.rasitus.rasitusluokat,
      keikkaId: keikkaId,
      varmenne: varmenne,
      commonHash: betoni.commonHash,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/rasitus/set",
    requestOptions
  ).catch((error) => console.log(error));
  if (!(await checkResponse(response).success)) return false;
}
export async function betoni_saveSlidersToDB(betoni, token, varmenne = null, keikkaId = 0) {
  cache_clear(keikkaBetoni_cacheName);
  const addr = "/api/keikka/betoni/setSliders";
  const keikkaBetoniId = betoni.keikkaBetoniId;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaBetoniId: keikkaBetoniId,
      laatuId: betoni.laatu.laatuId,
      isNopea: betoni.isNopea,
      raeKokoId: betoni.raeKoko.raeKokoId,
      lujuusId: betoni.lujuus.lujuusId,
      notkeusId: betoni.notkeus.notkeusId,
      raeKokoText: betoni.raeKoko.raeKokoText,
      lujuusText: betoni.lujuus.lujuusText,
      notkeusText: betoni.notkeus.notkeusText,
      kayttoIkaId: betoni.kayttoIka.kayttoIkaId,
      varmenne: varmenne,
      keikkaId: keikkaId,
      commonHash: betoni.commonHash,
    }),
  };
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, requestOptions)
    .then((response) => {
      if (!response.ok) {
        throw Error("Save failed");
      }
      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      throw Error(error);
    });
  return response;
}
export async function betoni_fetchKeikkaBetonit(keikkaId, token) {
  const url = import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/list/" + keikkaId;
  const c = cache_read(keikkaBetoni_cacheName, url);
  if (c) return c;
  const response = await fetch(url, {
    headers: {
      "x-access-token": `${token}`,
    },
  });
  const json = await response.json();
  cache_write(keikkaBetoni_cacheName, url, json, 0);
  return json;
}
export async function betoni_fetchShortCuts(asiakasId, token) {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/shortCuts/list/" + asiakasId;
  const c = cache_read(keikkaBetoni_cacheName, url);
  if (c) return c;
  const response = await fetch(url, {
    headers: {
      "x-access-token": `${token}`,
    },
  });
  const json = await response.json();
  cache_write(keikkaBetoni_cacheName, url, json, 0);
  return json;
}
export async function betoni_shortCuts_Add(asiakasId, shortCut, token) {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/shortCuts/add/" + asiakasId;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ shortcut: shortCut }),
  };
  const response = await fetch(url, requestOptions);
  cache_clear(keikkaBetoni_cacheName);
  return response.ok;
}
export async function betoni_shortCuts_save(asiakasId, shortCutData, token) {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/shortCuts/save/" + asiakasId;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(shortCutData),
  };
  const response = await fetch(url, requestOptions);
  const json = await response.json();
  cache_clear(keikkaBetoni_cacheName);
  return json;
}
export async function betoni_shortCuts_delete(betoniShortCutId, token) {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/shortCuts/delete/" + betoniShortCutId;
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(url, requestOptions);
  cache_clear(keikkaBetoni_cacheName);
  return response.ok;
}
